import { Component, OnInit, OnDestroy ,ViewChild} from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { MatTableDataSource, MatDialog, PageEvent,MatPaginator } from '@angular/material';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ComponentPageTitle } from 'src/app/page-title/page-title.component';
import { AppServiceService } from 'src/app/services/app-service.service';
import { BusquedaService } from '../busqueda.service';
import { CreateService } from '../createservice';
import { CreateEjeComponent } from '../create-eje/create-eje.component';
import { GatewayService } from 'src/app/gateway.service';
import { ConfirmacionComponent } from '../confirmacion/confirmacion.component';
import { FiltroPaisService } from '../filtro-pais.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
	selector: 'app-eje',
	templateUrl: './eje.component.html',
	styleUrls: ['./eje.component.scss']
})
export class EjeComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
	// campanaColumns: string[] = ['IDEJE', 'NOMBREEJE', 'COLOR', 'PAIS', 'ACCION'];
	// campanaColumns: string[] = ['NOMBREEJE', 'COLOR', 'PAIS', 'ACCION'];
	campanaColumns: string[] = ['NOMBREEJE', 'COLOR', 'ACCION'];
	dataSource = new MatTableDataSource<any>([]);
	private subscription: Subscription;
	private subscriptioncreate: Subscription;
	private subscriptionpais: Subscription;
	FILTER; resultsLength = 0;
	pageSize = 10;
	idpais;
	pageEvent: PageEvent;
	public actpage:number=0;

	@ViewChild('paginatoreje') paginatoreje: MatPaginator;

	constructor(
		private router: Router,
		private spinner: NgxSpinnerService,
		private gateway: GatewayService,
		public pageTitle: ComponentPageTitle,
		public _appservice: AppServiceService,
		public _busqueda: BusquedaService,
		public _create: CreateService,
		private dialog: MatDialog,
		public _filtroPais: FiltroPaisService,
		private localSave: LocalSaveService
	) { }

	cambioElementos(event?:PageEvent) { 
		this.actpage = event.pageIndex; 
		this.get(event.pageIndex);
	}

	ngOnInit() {
		const user = this.localSave.get('usuarioPGV');
		if (!user || user.idrol != 16) {
			this.router.navigate(['/home']);
		}
		this.idpais = this.localSave.get('pais');
		this.get(0);
		this.pageTitle.title = 'Ejes principales';
		// this.loadUsuarios();
		this.subscription = this._busqueda.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
			res => {
				this.filtrareje(res.filtro);
			});
		this.subscriptioncreate = this._create.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
			res => {
				this.createEje();
			});
		this.subscriptionpais = this._filtroPais.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
			res => {
				this.idpais = res.IDPAIS;
				this.get(0);
			}
		);
	}

	// ============== FILTRO ==============
	filter = '';
	public keyDownFunction(event) {
		if (event.keyCode == 13) {
			this.filtrogeneral();
		} else if (event.keyCode == 8 && this.filter == '') {
			this.filtrogeneral();
		}
	}
	public filtrogeneral() {
		this._busqueda.notificarBusqueda({ filtro: this.filter });
	}

	ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
		this.subscription.unsubscribe();
		this.subscriptioncreate.unsubscribe();
		this.subscriptionpais.unsubscribe();
	}

	get(page) {
		this.spinner.show();
		if(page == 0){
			this.paginatoreje.firstPage();
		}
		this.gateway.get('geteje', { NUM_PAGINA: page, FILTRO: this.FILTER, NUM_ELEMENTOS: this.pageSize, IDPAIS: this.idpais, IDPADRE: this.localSave.get('usuarioPGV').IDU, IDAREA: this.localSave.get('usuarioPGV').IDAREA }).then((result) => {
			let aux:any = result;
			//console.log(aux.rows);
			this.dataSource = aux.rows;
			//this.resultsLength = 3;//result[1][0].TOTAL;
			this.gateway.get('getejecount', { NUM_PAGINA: page, FILTRO: this.FILTER, NUM_ELEMENTOS: this.pageSize, IDPAIS: this.idpais, IDPADRE: this.localSave.get('usuarioPGV').IDU, IDAREA: this.localSave.get('usuarioPGV').IDAREA }).then((result:any) => {
				//console.log(result.rows);
				this.resultsLength = result.rows[0].total;
				this.spinner.hide();
			});
		}
		).catch(function (e) {
		});
	}

	createEje() {
		const dialogRef = this.dialog.open(CreateEjeComponent, {
			maxWidth: '90vw',
			width: '620px',
			minHeight: '20vh',
			data: { operacion: 'Crear', eje: {IDPAIS: this.idpais} },
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(result => {
			this.get(this.actpage);
		});
	}

	edit(element) {
		const dialogRef = this.dialog.open(CreateEjeComponent, {
			maxWidth: '90vw',
			width: '620px',
			minHeight: '20vh',
			data: { operacion: 'Editar', eje: element },
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(result => {
			if(result){
				this.get(this.actpage);
			}
		});
	}

	filtrareje(data) {
		this.FILTER = data;
		this.get(0)
	}

	delete(element) {
		const dialogRef = this.dialog.open(ConfirmacionComponent, {
			disableClose: true,
			width: '300px',
			data: { operacion: 'deleteeje', id: { IDEJE: element.ideje } }
		});

		dialogRef.afterClosed().subscribe((result) => {
			//console.log(result)
			this.get(0);

		});
	}

}

export interface EJE {
	IDEJE: number
	NOMBREEJE: string,
	COLOR: string
}

